import { DeliveryState } from '../api/shared';

export const getStateChipType = (state: DeliveryState): 'primary' | 'warning' | 'error' | 'secondary' => {
  switch (state) {
    case DeliveryState.DELIVERY_STATE_SUCCEEDED:
      return 'primary';
    case DeliveryState.DELIVERY_STATE_PENDING:
    case DeliveryState.DELIVERY_STATE_RUNNING:
      return 'secondary';
    case DeliveryState.DELIVERY_STATE_FAILED:
      return 'error';
    case DeliveryState.DELIVERY_STATE_CANCELLED:
      return 'warning';
    default:
      return 'secondary';
  }
};

export const getStateLabel = (state: DeliveryState): string => {
  switch (state) {
    case DeliveryState.DELIVERY_STATE_SUCCEEDED:
      return 'succeeded';
    case DeliveryState.DELIVERY_STATE_PENDING:
      return 'pending';
    case DeliveryState.DELIVERY_STATE_RUNNING:
      return 'running';
    case DeliveryState.DELIVERY_STATE_FAILED:
      return 'failed';
    case DeliveryState.DELIVERY_STATE_CANCELLED:
      return 'cancelled';
    default:
      return 'unknown';
  }
};
